import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiErrorModel } from '@api/http';
import { LoggingService } from '@shared/logging';
import { catchError, Observable, throwError } from 'rxjs';

@Injectable()
export class PingServerService {
	public constructor(
		private http: HttpClient,
		private loggingService: LoggingService
	) {}

	public testServerUrl<T>(connectionPath: string, endpoint: string): Observable<T> {
		const headers = this.setHeaders();
		// todo: use shareReplay to avoid maiking calls to db, keep in mind to reset when changing workfile
		return this.http.post<T>(`${connectionPath}${endpoint}`, { headers, withCredentials: false }).pipe(
			catchError((error: ApiErrorModel) => {
				this.loggingService.error(`Call failed for request ${endpoint}`, error.errorMessage);
				return throwError(() => error);
			})
		);
	}

	private setHeaders(): HttpHeaders {
		const headers = new HttpHeaders({
			Accept: 'application/json',
			'Content-Type': 'application/json'
		});
		return headers;
	}
}
